import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { getImageSrcSet, getImageUrl } from '../helpers/utils'
import { useNavigationStore } from '../state/navigationStore'
import { I_CasePost, useWpDataStore } from '../state/wpDataStore'
import { Accordion } from './Accordion'
import { CaseAttributes } from './CaseAttributes'
import { Modal } from './Modal'

const CaseModal = () => {
  const { caseModalOpen, setCaseModalOpen, selectedCasePostId } =
    useNavigationStore(
      useShallow((state) => ({
        caseModalOpen: state.caseModalOpen,
        setCaseModalOpen: state.setCaseModalOpen,
        selectedCasePostId: state.selectedCasePostId,
      }))
    )

  const selectedCasePost = useWpDataStore((s) =>
    s.getCaseById(selectedCasePostId)
  )

  return caseModalOpen ? (
    <Modal
      // faIcon='fa-file-lines'
      title='Case Study'
      onClose={() => {
        setCaseModalOpen(false)
      }}
    >
      {selectedCasePost && <CaseModalContent casePost={selectedCasePost} />}
    </Modal>
  ) : null
}

const CaseModalContent = ({ casePost }: { casePost: I_CasePost }) => {
  const { id, title, acf } = casePost
  const { featured_images, introduction, accordion } = acf || {}

  return (
    <div className='case-modal'>
      <h3 className='case-modal__title'>{title?.rendered || `#${id}`}</h3>

      {/* Attributes */}
      <CaseAttributes casePost={casePost} inModal />

      {featured_images && featured_images.length > 0 && (
        <div className='case-modal__featured-images'>
          {featured_images.map((item, index) => {
            const src =
              getImageUrl(item.image, 'large') ?? getImageUrl(item.image)
            if (!src) return null

            const srcSet = getImageSrcSet(item.image)
            // sizes is optional; adjust to your layout
            const sizes = '(min-width: 1024px) 800px, 100vw'

            return (
              <div key={index} className='case-modal__image'>
                <img
                  src={src}
                  srcSet={srcSet}
                  sizes={srcSet ? sizes : undefined}
                />
              </div>
            )
          })}
        </div>
      )}

      {introduction && (
        <div
          className='case-modal__introduction'
          dangerouslySetInnerHTML={{ __html: introduction }}
        />
      )}

      {accordion && accordion.length > 0 && <Accordion sections={accordion} />}
    </div>
  )
}

export { CaseModal }
